import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { DataHubService } from 'src/core/services/datahub';
import { TryAddPageCoverSchema } from 'src/core/services/datahub/schemas/content/tryAddPageCoverSchema';
import { EntityTypes } from 'src/core/services/upload/constants';
import { UploadCover } from 'src/shared/components/uploadCover';
import { HttpStatus } from 'src/shared/constants/httpStatus';
export function Cover({ mediaThumbnail }) {
    const { pageId } = useParams();
    const { t } = useTranslation();
    const { setValue, watch } = useFormContext();
    useEffect(function effectResetCover() {
        if (mediaThumbnail && watch('cover')) {
            setValue('cover', null, { shouldDirty: true });
        }
    }, [mediaThumbnail, setValue, watch]);
    function handleUploadEnd(fileId) {
        DataHubService.sendEvent({
            schema: new TryAddPageCoverSchema({
                result: fileId ? 'SUCCESSFUL' : 'FAILURE',
                statusCode: fileId ? HttpStatus.Ok : HttpStatus.InternalServerError
            })
        });
    }
    return (_jsx(UploadCover, { hideGalleryInfo: true, entityId: pageId, fieldName: "cover", value: watch('cover'), onUploadEnd: handleUploadEnd, priorityImage: mediaThumbnail, entityType: EntityTypes.PageBackgroundImg, label: t('content.form.content_cover.label'), isUpdate: Boolean(pageId) && pageId !== 'new', tooltip: t('content.form.content_cover.tooltip'), hideActionButton: Boolean(watch('medias')?.length) }));
}
